import { Dialog } from "@surya-digital/leo-reactjs-material-ui";
import { observer } from "mobx-react";
import React, { useState } from "react";
import { ConfirmEmailTemplateDeletionDialogContent } from "./contents/ConfirmEmailTemplateDeletionDialogContent";
import { useDeleteEmailTemplateStore } from "../../stores/Hooks";
import { useRouteNavigator } from "../../../../routes/RoutesHelper";
import { DeleteEmailTemplateRPC } from "@pulse/pulse-rpcs/lib/email-cycle/deleteEmailTemplateRPC";
import { useTranslation } from "react-i18next";
import { UnexpectedErrorDialog } from "../../../../components/dialogs/UnexpectedErrorDialog";

interface ConfirmEmailTemplateDeletionDialogProps {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const CONFIRM_DELETE_DIALOG_WIDTH = "560px";

export const ConfirmEmailTemplateDeletionDialog: React.FC<ConfirmEmailTemplateDeletionDialogProps> =
  observer(({ open, setOpen }) => {
    const [openUnexpectedErrorDialog, setOpenUnexpectedErrorDialog] =
      useState(false);

    const { t } = useTranslation();
    const navigateTo = useRouteNavigator();
    const deleteEmailTemplateStore = useDeleteEmailTemplateStore();

    const handleEmailTemplateDeletion = async (): Promise<void> => {
      await deleteEmailTemplateStore
        .deleteEmailTemplate()
        .catch(() => setOpenUnexpectedErrorDialog(true));

      switch (deleteEmailTemplateStore.deleteEmailTemplateRPCError) {
        case null:
          setOpen(false);
          navigateTo.emailTemplates();
          break;
        case DeleteEmailTemplateRPC.RPCError.InvalidTemplateId:
          navigateTo.pageNotFound();
          break;
        default:
          deleteEmailTemplateStore.deleteEmailTemplateRPCError satisfies never;
      }
    };

    return (
      <>
        <Dialog
          open={open}
          title={`${t("emailTemplates.deleteEmailTemplate")}?`}
          primaryButtonText={t("emailTemplates.deleteEmailTemplate")}
          primaryButtonColor="destructive"
          onPrimaryButtonClick={handleEmailTemplateDeletion}
          secondaryButtonText={t("common.cancel")}
          onSecondaryButtonClick={() => setOpen(false)}
          width={CONFIRM_DELETE_DIALOG_WIDTH}
          onClose={deleteEmailTemplateStore.resetStore}
          disableBackdropClick={true}
        >
          <ConfirmEmailTemplateDeletionDialogContent />
        </Dialog>

        {openUnexpectedErrorDialog && (
          <UnexpectedErrorDialog
            message={t(
              "emailTemplates.deletionUnexpectedErrorDialogDescription",
            )}
            onClickDone={() => {
              setOpenUnexpectedErrorDialog(false);
              deleteEmailTemplateStore.resetStore();
            }}
          />
        )}
      </>
    );
  });
